<template>
<div class="card-container">
  <div class="device-list" v-for="(item, index) of gateway.children" :key="index">{{item.name}}</div>
  <div v-if="gateway.children.length === 0" class="no-device">
    <h3>暂无设备</h3>
  </div>
</div>
</template>

<script>
import { getDeviceOnGateway } from '../utils/getDeviceOnGateway'
export default {
  name: 'CardContent',
  props: ['API', 'index'],
  data() {
    return {
      loading: true,
      gateway: {}
    }
  },
  async created() {
    this.gateway = this.API.filter.filteredList[this.index]
    // await this.getDevice()
  },
  methods: {
    async getDevice() {
      this.gateway.loading = true
      this.gatewaychildren = await getDeviceOnGateway(this.gateway.shortId)
      this.gateway.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  display: flex;
  flex-direction: column;
  height: 250px;
  overflow-y: auto;
  // scrollbar-width: none;
  // &::-webkit-scrollbar {
  //   display: none;
  // }
   .device-list {
    //  margin: 3px 0;
     padding: 14px 14px;
     &:nth-child(odd) {
       background-color: #F3F6Fc;
     }
   }
   .no-device {
     width: 100%;
     height: 100%;
     display: flex;
     align-content: center;
     align-items: center;
     justify-content: center;
     h3 {
       font-weight: normal;
       color: #999;
     }
   }
}
</style>
